export const parseMarginRateInput = (value: unknown): unknown => {
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed === '') return '';
    return trimmed.replace(',', '.');
  }

  return value;
};

export const parseMarginRateNumber = (value: unknown): number | undefined => {
  if (value === null || value === undefined || value === '') return undefined;
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : undefined;
  }
  if (typeof value !== 'string') return undefined;

  const parsed = Number(parseMarginRateInput(value));
  return Number.isFinite(parsed) ? parsed : undefined;
};
